import { useState } from "react";
import styled from "styled-components";
import theme from "../../style/theme";
import { BasePageDto } from "../../types/pages";
import LeftAngleBracketLineIcon from "../icons/LeftAngleBracketLineIcon";
import RightAngleBracketLineIcon from "../icons/RightAngleBracketLineIcon";
import useEventBus from "../../utils/eventbus/use-event-bus";
import {EventTypes} from "../../utils/eventbus/event-bus";

interface Props {
  basePage: BasePageDto<any>;
  onPageChange: (selectedItem: { selected: number }) => void;
}

export const PageController: React.FC<Props> = ({ basePage, onPageChange }) => {
  const [pageIndex, setPageIndex] = useState(0);
  const isFirstPageIndex = pageIndex === 0;
  const isLastPageIndex = Math.ceil(basePage.totalPages / 10) <= pageIndex + 1;
  const pageListLength = isLastPageIndex
    ? basePage.totalPages - pageIndex * 10
    : 10;
  const pageList = Array.from(
    { length: pageListLength },
    (_, index) => index + 1
  );

  useEventBus(EventTypes.PAGE_CLEAR, () => {
    setPageIndex(0);
  });

  const handleClickLeftButton = () => {
    if (!isFirstPageIndex) {
      const newPageIndex = pageIndex - 1;
      onPageChange({ selected: pageIndex * 10 - 1 });
      setPageIndex(newPageIndex);
    }
  };

  const handleClickRightButton = () => {
    if (!isLastPageIndex) {
      const newPageIndex = pageIndex + 1;
      onPageChange({ selected: newPageIndex * 10 });
      setPageIndex(newPageIndex);
    }
  };

  const handleClickPageButton = (page: number) => {
    onPageChange({ selected: page + pageIndex * 10 - 1 });
  };

  return (
    <PageControllerContainer>
      <IconContainer onClick={handleClickLeftButton}>
        <LeftAngleBracketLineIcon
          fill={
            isFirstPageIndex
              ? `${theme.palette.primitives.gray300}`
              : "#000000"
          }
        />
      </IconContainer>

      {pageList.map((page) => {
        const pageText = page + pageIndex * 10;
        const isSelected = pageText - 1 === basePage.page;

        return (
          <PageButton
            key={pageText}
            isSelected={isSelected}
            onClick={() => handleClickPageButton(page)}
          >
            {pageText}
          </PageButton>
        );
      })}
      <IconContainer onClick={handleClickRightButton}>
        <RightAngleBracketLineIcon
          fill={
            isLastPageIndex ? `${theme.palette.primitives.gray300}` : "#000000"
          }
        />
      </IconContainer>
    </PageControllerContainer>
  );
};

const PageControllerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
`;

const IconContainer = styled.div`
  padding: 0 17px;
  cursor: pointer;
`;

interface PageButtonProps {
  isSelected: boolean;
}

const PageButton = styled.div<PageButtonProps>`
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  margin: 0 6px;
  cursor: pointer;
  background-color: ${({ isSelected }) =>
    isSelected ? theme.palette.primitives.gray100 : "white"};
`;
